<!-- 上下限设置 -->
<template>
    <div class="warehouseOut" v-loading="loading">
        <div class="warehouseOut-main">
            <div class="div-table-row table-title">
                <div class="div-table-cell" style="width: 30%">仓库</div>
                <div class="div-table-cell" style="width: 25%">上限</div>
                <div class="div-table-cell" style="width: 25%">下限</div>
                <div class="div-table-cell" style="width: 20%">浮动幅度</div>
            </div>
            <div class="table-main">
                <div class="div-table-row" v-for="wh in  warehouseList " :key="wh.Id">
                    <div class="div-table-cell" style="width:30%">
                        {{ wh.Name }} {{ wh.MainSto ? "（主仓）" : "" }}
                    </div>
                    <div class="div-table-cell" style="width: 25%">
                        <el-input-number size="small" :precision="0" controls-position="right" :step="1" v-model="wh.UpLimit"
                            :min="wh.LowerLimit > 0 ? (wh.LowerLimit + 1): 0 "></el-input-number>
                    </div>
                    <div class="div-table-cell" style="width: 25%">
                        <el-input-number size="small" :precision="0" controls-position="right" :step="1" v-model="wh.LowerLimit" :min="0"
                            :max="wh.UpLimit - 1"></el-input-number>
                    </div>
                    <div class="div-table-cell" style="width: 20%">
                        <el-input-number size="small" :precision=" 0 " controls-position="right" :step=" 1 " v-model=" wh.FloatRange " :min=" 1 "></el-input-number>
                    </div>
                </div>
            </div>
        </div>
        <div class="dialog-footer">
            <el-button size="small" @click=" cancel ">取消</el-button>
            <el-button class="btn-primary" size="small" @click=" comfirm ">确定</el-button>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: ['GoodsId', 'IsSave'],
    components: {},
    data() {
        return {
            Limit: 10,
            loading: false,
            warehouseList: [],
            dataList: [],
        };
    },
    mounted() {
        let that = this;

        if (this.IsSave && this.IsSave == "1" && !this.GoodsId) {
            this.$util.warningMsg('商品数据异常，请刷新后重新操作');
            return;
        }

        //获取仓库列表
        that.getWarehouse();
    },
    methods: {
        getWarehouse() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetEntpGoodsLimits',
                    data: { GoodsId: this.GoodsId },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    this.warehouseList = data;
                })
                .catch(() => { })
                .finally(() => {
                    this.loading = false;
                });
        },
        cancel() {
            this.$emit('closeDialog');
        },
        comfirm() {
            let that = this;
            for (let i = 0; i < that.warehouseList.length; i++) {
                if (that.warehouseList[i].LowerLimit != that.warehouseList[i].UpLimit) {
                    if (parseInt(that.warehouseList[i].LowerLimit) > parseInt(that.warehouseList[i]).UpLimit) {
                        that.$util.warningMsg('上限必须大于上限');
                        return;
                    }
                }
            }
            if (that.IsSave && that.IsSave == '1') {
                if (that.warehouseList && that.warehouseList.length > 0) {
                    that.loading = true;
                    that.$util
                        .axiosPost({
                            url: '/api/EntpGoods/SaveGoodsLimits',
                            data: {
                                GoodsId: that.GoodsId,
                                LimitSets: that.warehouseList
                            },
                            hideLoading: true
                        })
                        .then(response => {
                            if (response.errcode == 0) {
                                that.$util.successMsg('设置成功');
                                that.$emit('closeDialog');
                            }
                        })
                        .catch(error => {
                            that.loading = false;
                        });
                }
                else
                    that.$util.warningMsg('未检测到设置数据');
            }
            else
                that.$emit('closeDialog', that.warehouseList);
        }
    }
};
</script>
<style lang="less" scoped>
.add-btn {
    position: absolute;
    right: 10px;
    bottom: 6px;
}

.ops-ctn {
    text-align: left !important;
}

.dialog-header {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.tips {
    color: #f00;
    margin-top: 4px;
    margin-left: 4px;
}

.dialog-footer {
    text-align: right;
}

.warehouseOut-main {
    padding: 10px 0;
}

.table-title {
    background: #f2f6fc;

    .cell-item {
        width: 33.33%;
    }

    .div-table-cell {
        text-align: center;
        height: 36px;
        line-height: 36px;
    }
}

.div-table-row {
    position: relative;
    overflow: visible;
}

.table-main {
    .div-table-cell {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }

    .cell-line {
        display: flex;
        width: 100%;
    }

    .cell-item {
        padding: 0 10px;
        width: 33%;
        width: inherit;
        text-align: center;
        height: 40px;
        line-height: 40px;
    }
}
</style>
